import * as THREE from 'three';

export class circle {
    public center: THREE.Vector2;
    public r: number;

    constructor (center: THREE.Vector2, r: number) {
        this.center = center;
        this.r = r;
    }
}
